export const GET_COMPANY_USER_SINGLE_REQUEST = 'GET_COMPANY_USER_SINGLE_REQUEST'
export const GET_COMPANY_USER_SINGLE_RESET = 'GET_COMPANY_USER_SINGLE_RESET'
export const GET_COMPANY_USER_SINGLE_SUCCESS = 'GET_COMPANY_USER_SINGLE_SUCCESS'
export const GET_COMPANY_USER_SINGLE_ERROR = 'GET_COMPANY_USER_SINGLE_ERROR'
